import { render, staticRenderFns } from "./ModalCesta.vue?vue&type=template&id=54c9b5ed"
import script from "./ModalCesta.vue?vue&type=script&lang=js"
export * from "./ModalCesta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports